import { render, staticRenderFns } from "./PostAvatar.vue?vue&type=template&id=b05849c8"
import script from "./PostAvatar.vue?vue&type=script&lang=ts"
export * from "./PostAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports